import { useChecklist } from '@/hooks/questionnaire.hooks';

export const Checklist = () => {
  const checklistItems = useChecklist();

  return (
    <div className="bg-[var(--dbg-bg)] flex flex-col p-4 gap-1">
      {checklistItems.map((item, i) => (
        <div
          key={i}
          className="bg-[var(--dbg-bg-secondary)] rounded p-2 flex items-center justify-between gap-2"
        >
          <span className="text-[var(--dbg-text)] text-sm font-mono">
            {item.value}
          </span>
          <span className="bg-[var(--dbg-hover)] text-[var(--dbg-text-muted)] text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
            {item.family}
          </span>
        </div>
      ))}
    </div>
  );
};
